import React from 'react';
import { connect } from 'react-redux';
import {
  invoicesPageRequest,
  changeDateInvoices,
  changeOutletInvoices,
  changeStatusInvoices,
  listInvoiceRequest,
  receiptInvoicesRequest,
  hideReceiptInvoice,
  resendEmail,
  printReceiptInvoicePdf,
  showCancelInvoiceModal,
  showOldCancelInvoiceModal,
  onClickRecordPayment,
  onCancelRecordPayment,
  setListInvoice,
} from 'actions/reports/invoices';
import { currencyFormatter } from 'utils/formatter';
import ReceiptButtonGroup from 'components/receipt/invoices/ButtonGroup/ReceiptButtonGroup';
import RecordPaymentModal from 'components/receipt/invoices/RecordPaymentModal/RecordPaymentModal';
import CancelInvoiceModal from 'components/receipt/refunds/CancelInvoiceModal';
import OldCancelInvoiceModal from 'components/receipt/refunds/OldCancelInvoiceModal';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import InfiniteScroll from 'react-infinite-scroller';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import { getFormattedTime } from 'utils/hourFilter';
import ActionBar from './ActionBar';
import ReceiptInvoicesModal from './ReceiptInvoices/ReceiptInvoicesModal';
import ReceiptInvoices from './ReceiptInvoices';
import styles from './style.css';

class Invoices extends React.Component {
  static INVOICE_STATUS = {
    cancelled: 'Cancelled',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    paid: 'Paid',
    partially_paid: 'Partially Paid',
  };

  constructor(props) {
    super(props);
    this.state = {
      openRecordPayment: false,
      openRefundBreakdownModal: false,
      invoice: null,
      invoiceDetailOpened: false,
      isMobile: false,
      showModal: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(invoicesPageRequest());
  }

  render() {
    const { invoices, receiptInvoices } = this.props.data.reports.invoices;
    const { showLoadingSpinnerPage } = this.props.data.loadingSpinner;

    return (
      <div
        className={`container-full-nosub ${styles['invoice-report']}`}
        id="invoice-content"
      >
        <div className="container no-padding invoice-container">
          <div className="mk-action-bar">
            <div>
              <div className="col-sm-12 col-xs-12 no-padding">
                <ActionBar
                  onChangeOutlet={this._onChangeOutlet}
                  onChangeDate={this._onChangeDate}
                  onChangeStatuses={this._onChangeStatuses}
                  onChangeKeyword={this._onSearch}
                  search={this.props.search}
                />
              </div>
            </div>
          </div>
          <div className={styles['invoice-table']}>
            <div className={styles['mk-report-invoice']}>
              <div className={styles['row-invoice']}>
                <div className="col-sm-12 trans-1 no-padding" id="mk-col-left">
                  <NoDataAndLoading
                    showLoadingSpinner={showLoadingSpinnerPage}
                    noDataToDisplay={invoices && invoices.length === 0}
                    title="No Data To Display"
                    description="You can make invoice through your device, or select different time frame."
                    linkLabel="Make an Invoice"
                    linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000442743-Cara-Melakukan-Transaksi-dengan-Menggunakan-Invoice"
                  />
                  {invoices && invoices.length > 0 && (
                    <div
                      className={`${styles['div-invoice-table']} ${
                        showLoadingSpinnerPage ? styles['hide-table'] : ''
                      }`}
                    >
                      <table
                        id="invoice-table"
                        className={styles['table-header']}
                      >
                        <thead>
                          <tr>
                            <th className="text-center">Date</th>
                            <th className="visible-md visible-lg">
                              Invoice Number
                            </th>
                            {this._showOutletColumn() && <th>Outlet</th>}
                            <th className>Customer Name</th>
                            <th>Status</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                      </table>
                      <div
                        className={`${
                          styles['table-content-wrapper']
                        } invoice-table-content-wrapper`}
                      >
                        <InfiniteScroll
                          pageStart={1}
                          loadMore={this._onReachBottom}
                          hasMore={this._hasMore()}
                          useWindow={false}
                          threshold={10}
                          initialLoad={false}
                        >
                          <table className={styles['table-content']}>
                            <tbody id="invoice-table-tbody">
                              {invoices.map((invoice, idx) => {
                                const boundRowClick = this._showReceiptInvoices.bind(
                                  this,
                                  invoice.id
                                );
                                return (
                                  <tr
                                    className={
                                      receiptInvoices !== null &&
                                      invoice.parent_payment_id ===
                                        receiptInvoices.id
                                        ? 'invoice-row selected'
                                        : 'invoice-row'
                                    }
                                    key={idx}
                                    onClick={boundRowClick}
                                  >
                                    <td className="text-center">
                                      {this._dateFormatColumn(invoice)}
                                    </td>
                                    <td className="visible-md visible-lg">
                                      {invoice.invoice_no}
                                    </td>
                                    {this._showOutletColumn() && (
                                      <td className={styles['col-outlet']}>
                                        {invoice.outlet_name}
                                      </td>
                                    )}
                                    <td>
                                      {invoice.customer_name}
                                      {!invoice.customer_name &&
                                        invoice.customer_email}
                                    </td>
                                    <td
                                      className={styles['col-status']}
                                      dangerouslySetInnerHTML={{
                                        __html: invoice.status_formatter,
                                      }}
                                    />
                                    <td>
                                      {invoice.is_refunded
                                        ? `(${currencyFormatter(
                                            invoice.total_collected
                                          )})`
                                        : currencyFormatter(
                                            invoice.total_collected
                                          )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </InfiniteScroll>
                      </div>
                    </div>
                  )}
                </div>
                {receiptInvoices !== null &&
                  !this.state.isMobile &&
                  this.state.invoiceDetailOpened && (
                    <div className="col-sm-12 trans-1" id="mk-col-right">
                      <ReceiptButtonGroup
                        clickResendButton={() =>
                          this._onClickResendButton(receiptInvoices.id)
                        }
                        invoiceDetail={receiptInvoices}
                        onClickRecordPayment={this._onClickRecordPayment}
                        onClickPrintButton={() =>
                          this._showReceiptInvoicePdf(receiptInvoices.id)
                        }
                        onCancelInvoice={
                          receiptInvoices.is_refund_breakdown
                            ? this._onClickCancelInvoiceRefundBreakdown
                            : this._onClickCancelInvoiceOldRefund
                        }
                      />
                      <div className={'mk-col-right-box'}>
                        <ReceiptInvoices invoiceDetail={receiptInvoices} />
                      </div>
                      <div className="mk-col-right-action-box bottom invoice-done">
                        <button
                          className="btn btn-primary pull-right"
                          id="btn-close"
                          onClick={this._hideReceipt}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}
                {this.state.isMobile && receiptInvoices !== null && (
                  <ReceiptInvoicesModal
                    onClickDoneButton={this._hideReceipt}
                    _onClickResendButton={() =>
                      this._onClickResendButton(receiptInvoices.id)
                    }
                    receiptInvoices={receiptInvoices}
                    _onClickRecordPayment={this._onClickRecordPayment}
                    _showReceiptInvoicePdf={() =>
                      this._showReceiptInvoicePdf(receiptInvoices.id)
                    }
                    onCancelInvoice={
                      !receiptInvoices.is_refund_breakdown
                        ? this._onClickCancelInvoiceOldRefund
                        : this._onClickCancelInvoiceRefundBreakdown
                    }
                    show={this.state.showModal}
                    onHide={this._hideReceipt}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {receiptInvoices !== null && (
          <RecordPaymentModal
            closeRecordPaymentModal={this._onHideRecordPayment}
            onClickCancel={this._onHideRecordPayment}
          />
        )}
        {receiptInvoices !== null && <CancelInvoiceModal />}
        {receiptInvoices !== null && <OldCancelInvoiceModal />}
      </div>
    );
  }

  _onChangeOutlet = (outletIds = []) => {
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
      keyword,
      statuses,
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletInvoices(
        outletIds,
        formattedStart,
        formattedEnd,
        statuses,
        keyword
      )
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { keyword, statuses } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeDateInvoices(formattedStart, formattedEnd, statuses, keyword)
    );
  };

  _onChangeStatuses = statuses => {
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
      keyword,
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeStatusInvoices(statuses, formattedStart, formattedEnd, keyword)
    );
  };

  _onSearch = keyword => {
    // close right column
    const toggledClass = 'col-sm-12 col-md-6 col-xs-6';
    $('#mk-col-left, #mk-col-right').removeClass(toggledClass);
    $('#mk-col-left').addClass('col-sm-12');
    $('#mk-col-right').hide();

    const {
      date: { startDate, endDate, startHour, endHour, allDay },
      statuses,
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const startDateFormatted = moment(formattedStart).format(
      'D/M/YYYY HH:mm:ss'
    );
    const endDateFormatted = moment(formattedEnd).format('D/M/YYYY HH:mm:ss');
    const { dispatch } = this.props;
    dispatch(setListInvoice(null));
    dispatch(showPageLoadingSpinner(true));
    dispatch(
      listInvoiceRequest({
        startDate: startDateFormatted,
        endDate: endDateFormatted,
        keyword,
        status: statuses,
        page: 1,
      })
    );
  };

  _hideReceipt = () => {
    const isMobile =
      document.getElementsByClassName('visible-md')[0].offsetParent == null;
    this.setState({
      invoice: null,
      invoiceDetailOpened: false,
      isMobile,
      showModal: false,
    });
    this.props.dispatch(hideReceiptInvoice(isMobile));
  };

  _onClickResendButton = invoiceId => {
    this.props.dispatch(resendEmail(invoiceId));
  };

  _onClickRecordPayment = () => {
    this.props.dispatch(onClickRecordPayment());
  };

  _onHideRecordPayment = () => {
    this.props.dispatch(onCancelRecordPayment());
  };

  _showReceiptInvoicePdf = invoiceId => {
    this.props.dispatch(printReceiptInvoicePdf(invoiceId));
  };

  _onClickCancelInvoiceRefundBreakdown = () => {
    this.props.dispatch(showCancelInvoiceModal());
  };

  _onClickCancelInvoiceOldRefund = () => {
    this.props.dispatch(showOldCancelInvoiceModal());
  };

  _showReceiptInvoices = invoice => {
    const isMobile =
      document.getElementsByClassName('visible-md')[0].offsetParent == null;
    this.setState({
      invoice,
      invoiceDetailOpened: !isMobile,
      isMobile,
      showModal: isMobile,
    });
    this.props.dispatch(receiptInvoicesRequest(invoice, isMobile));
  };

  _showOutletColumn = () => {
    const {
      search: { outlet },
    } = this.props;
    return outlet && outlet.length > 1;
  };

  /**
   *
   * @param {string} date from server
   * @private
   */
  _dateFormatColumn = invoice => {
    const today = new Date();
    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    const formattedToday = moment(today).format('DD/MM/YYYY');
    const formattedYesterday = moment(yesterday).format('DD/MM/YYYY');
    const invoiceDate = invoice.is_refunded
      ? invoice.refunded_date
      : invoice.created_at;
    const formattedCreatedAt = moment(invoiceDate).format('DD/MM/YYYY');
    return formattedCreatedAt === formattedToday
      ? 'Today'
      : formattedCreatedAt === formattedYesterday
      ? 'Yesterday'
      : moment(invoice.created_at).format('DD MMM YYYY');
  };

  _onReachBottom = () => {
    const { currentPage, invoices } = this.props.data.reports.invoices;
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { keyword, statuses } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const formattedStartDate = moment(formattedStart).format(
      'D/MM/YYYY HH:mm:ss'
    );
    const formattedEndDate = moment(formattedEnd).format('D/MM/YYYY HH:mm:ss');
    this.props.dispatch(
      listInvoiceRequest(
        {
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          keyword,
          page: currentPage + 1,
          status: statuses,
        },
        invoices
      )
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props.data.reports.invoices;
    return currentPage < totalPage;
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
      keyword: selector(state, 'keyword'),
      statuses: selector(state, 'statuses'),
    },
    data: {
      category: state.category,
      reports: state.reports,
      loadingSpinner: state.loadingSpinner,
    },
  };
}

export default connect(mapStateToProps)(Invoices);
